import Vue from "vue";

export const store = Vue.observable({
    ProfileChild: false,
    DynamicChild: false,
    MailehuiChild: false,
    MaixueyuanChild: false
});

export const mutations = {
    setProfileChild(params) {
        store.ProfileChild = params;
    },
    setDynamicChild(params) {
        store.DynamicChild = params;
    },
    setMailehuiChild(params) {
        store.MailehuiChild = params;
    },
    setMaixueyuanChild(params) {
        store.MaixueyuanChild = params;
    }
};
